import { createStore } from "zustand";

export interface VirtualListStore {
	measurementLookup: Record<
		string,
		{
			y: number;
			height: number;
		}
	>;
	isCellLookup: Record<
		string,
		{
			isCell: boolean;
		}
	>;
	topOffset: number;
	scrollPosition: number;
	windowHeight: number;
}

export const createVirtualListStore = () => {
	return createStore<VirtualListStore>((set) => ({
		topOffset: 0,
		measurementLookup: {},
		isCellLookup: {},
		scrollPosition: 0,
		windowHeight: window.innerHeight,
	}));
};
